
import { useEffect, useRef, useState } from "react";

// 항상 따라다니는 작은 점
function SmallDot() {
    const dotRef = useRef(null);

    useEffect(() => {
        const move = (e) => {
            if (dotRef.current) {
                // 마우스 포인터에 딱 붙어있도록 즉시 위치 설정
                dotRef.current.style.left = `${e.clientX}px`;
                dotRef.current.style.top = `${e.clientY}px`;
            }
        };
        window.addEventListener("mousemove", move);
        
        // 기본 마우스 커서 숨기기
        document.body.style.cursor = 'none';
        
        return () => {
            window.removeEventListener("mousemove", move);
            document.body.style.cursor = '';
        };
    }, []);

    return (
        <div
            ref={dotRef}
            style={{
                position: "fixed",
                left: 0,
                top: 0,
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "#FF5670",
                pointerEvents: "none",
                boxShadow: "0 3px 10px 0 rgba(255,87,112,0.09)",
                transform: "translate(-50%, -50%)",
                zIndex: 9998,
                opacity: 1,
                userSelect: "none",
            }}
        />
    );
}


// 메인 export 컴포넌트
export default function MouseDot() {
    const [isTablet, setIsTablet] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsTablet(window.innerWidth <= 1024);
        };
        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);
        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    if (isTablet) {
        return null; // 1024px 이하에서는 아무것도 렌더링하지 않음
    }

    return <SmallDot />;
}
